var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultipleChoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 13C17.48 13 13 17.48 13 23C13 28.52 17.48 33 23 33C28.52 33 33 28.52 33 23C33 17.48 28.52 13 23 13ZM23 31C18.58 31 15 27.42 15 23C15 18.58 18.58 15 23 15C27.42 15 31 18.58 31 23C31 27.42 27.42 31 23 31ZM28 23C28 25.7614 25.7614 28 23 28C20.2386 28 18 25.7614 18 23C18 20.2386 20.2386 18 23 18C25.7614 18 28 20.2386 28 23Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleChoice);
export default __webpack_public_path__ + "static/media/MultipleChoice.2aa96a2de02c9210285ea567330b07d6.svg";
export { ForwardRef as ReactComponent };